import * as types from './mutation-types'


export const AllDocumentTypes =({commit, dispatch, state}, params)=>{
   return new Promise((resolve, reject)=>{
       window.axios.get(`/api/settings/documentTypes`, { params }).then((response)=>{
           commit(types.DOCUMENT_TYPES, response.data.documentTypes)
           commit(types.ATTACH_OPTIONS, response.data.attachOptions)
           resolve(response)
       }).catch((err)=>reject(err))
   });
}
export const addDocumentType = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/settings/documentTypes', data).then((response) => {
            commit(types.ADD_DOCUMENT_TYPE, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const EditDocumentType = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/settings/documentTypes/${id}/edit`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const updateDocumentType = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`/api/settings/documentTypes/${data.id}`, data).then((response) => {
            commit(types.UPDATE_DOCUMENT_TYPE, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteDocumentType = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`/api/settings/documentTypes/${id}`).then((response) => {
            if (response.data.success) {
                commit(types.DELETE_DOCUMENT_TYPE, id)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

//invoice Attachments
export const fetchInvoiceDocumentTypes = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/invoiceDocumentType`).then((response) => {
            commit(types.BOOTSTRAP_INVOICE_DOCUMENTTYPES, response.data.documentTypes)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const fetchPODocumentTypes = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/poDocumentType`).then((response) => {
            commit(types.BOOTSTRAP_PO_DOCUMENTTYPES, response.data.documentTypes)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const fetchProcessDocumentTypes = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/processDocumentType`).then((response) => {
            commit(types.BOOTSTRAP_PROCESS_DOCUMENTTYPES, response.data.documentTypes)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const addAttachment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/invoices/addAttachment`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const addPreapprovedInvoiceAttachment = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
      window.axios.post(`/api/preapproved-invoices/addAttachment`, data).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const fetchAttachments = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/invoices/attachments`, data).then((response) => {
            commit(types.ATTACHMENTS, response.data.invoice.media)
            commit(types.SET_TOTAL_ATTACHMENTS, response.data.total)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const fetchPreapprovedInvoiceAttachments = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
      window.axios.post(`/api/preapproved-invoices/attachments`, data).then((response) => {
          commit(types.PREAPPROVED_INVOICE_ATTACHMENTS, response.data.invoice.media)
          commit(types.SET_TOTAL_PREAPPROVED_INVOICE_ATTACHMENTS, response.data.total)
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const setSelectAllState = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECT_ALL_STATE, data)
}

export const setSelectAllPreapprovedInvoiceState = ({ commit, dispatch, state }, data) => {
  console.log(data)
  commit(types.SET_SELECT_ALL_PREAPPROVED_INVOICE_STATE, data)
}

export const selectAllAttachments = ({ commit, dispatch, state }) => {
    if (state.selectedAttachments.length === state.attachments.length) {
        commit(types.SET_SELECTED_ATTACHMENTS, [])
        commit(types.SET_SELECT_ALL_STATE, false)
    } else {
        let allAttachmentIds = state.attachments.map(cust => cust.id)
        commit(types.SET_SELECTED_ATTACHMENTS, allAttachmentIds)
        commit(types.SET_SELECT_ALL_STATE, true)
    }
}

export const selectAllPreapprovedInvoiceAttachments = ({ commit, dispatch, state }) => {
  if (state.preapprovedInvoiceSelectedAttachments.length === state.preapprovedInvoiceAttachments.length) {
      commit(types.SET_SELECTED_PREAPPROVED_INVOICE_ATTACHMENTS, [])
      commit(types.SET_SELECT_ALL_PREAPPROVED_INVOICE_STATE, false)
  } else {
      let allAttachmentIds = state.preapprovedInvoiceAttachments.map(cust => cust.id)
      commit(types.SET_SELECTED_PREAPPROVED_INVOICE_ATTACHMENTS, allAttachmentIds)
      commit(types.SET_SELECT_ALL_PREAPPROVED_INVOICE_STATE, true)
  }
}

export const selectAttachment = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECTED_ATTACHMENTS, data)
    if (state.selectedAttachments.length === state.attachments.length) {
        commit(types.SET_SELECT_ALL_STATE, true)
    } else {
        commit(types.SET_SELECT_ALL_STATE, false)
    }
}
export const selectPreapprovedInvoiceAttachment = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_PREAPPROVED_INVOICE_ATTACHMENTS, data)
  if (state.selectedAttachments.length === state.attachments.length) {
      commit(types.SET_SELECT_ALL_PREAPPROVED_INVOICE_STATE, true)
  } else {
      commit(types.SET_SELECT_ALL_PREAPPROVED_INVOICE_STATE, false)
  }
}

export const deleteAttachment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/invoices/deleteAttachment`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deletePreapprovedInvoiceAttachment = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
      window.axios.post(`/api/preapproved-invoices/deleteAttachment`, data).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const deleteMultipleAttachments = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/invoices/deleteAttachments`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteMultiplePreapprovedInvoiceAttachments = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
      window.axios.post(`/api/preapproved-invoices/deleteAttachments`, data).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}
// prepayment Request Attachments
export const addPrepaymentAttachment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/prepaymentRequest/addAttachment`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const fetchPrepaymentAttachments = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/prepaymentRequest/attachments`, data).then((response) => {

            commit(types.PREPAYMENT_ATTACHMENTS, response.data.prepayment.media)
            commit(types.SET_TOTAL_PREPAYMENT_ATTACHMENTS, response.data.total)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const setSelectAllPrepaymentState = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECT_ALL_PREPAYMENT_STATE, data)
}

export const selectAllPrepaymentAttachments = ({ commit, dispatch, state }) => {
    if (state.selectedPrepaymentAttachments.length === state.prepaymentAttachments.length) {
        commit(types.SET_SELECTED_PREPAYMENT_ATTACHMENTS, [])
        commit(types.SET_SELECT_ALL_PREPAYMENT_STATE, false)
    } else {
        let allPrepaymentAttachmentIds = state.prepaymentAttachments.map(cust => cust.id)
        commit(types.SET_SELECTED_PREPAYMENT_ATTACHMENTS, allPrepaymentAttachmentIds)
        commit(types.SET_SELECT_ALL_PREPAYMENT_STATE, true)
    }
}
export const selectPrepaymentAttachment = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECTED_PREPAYMENT_ATTACHMENTS, data)
    if (state.selectedPrepaymentAttachments.length === state.prepaymentAttachments.length) {
        commit(types.SET_SELECT_ALL_PREPAYMENT_STATE, true)
    } else {
        commit(types.SET_SELECT_ALL_PREPAYMENT_STATE, false)
    }
}
export const deletePrepaymentAttachment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/prepaymentRequest/deleteAttachment`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const deleteMultiplePrepaymentAttachments = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/prepaymentRequest/deleteAttachments`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
//profile documents


export const profileDocuments = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/businessProfile/attachments`, data).then((response) => {
            commit(types.PROFILE_DOCUMENTS, response.data.profileDocuments)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const addCompanyAttachment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/businessProfile/addAttachment`, data).then((response) => {

            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const fetchCompanyAttachments = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/businessProfile/attachments`, data).then((response) => {
            commit(types.PROFILE_DOCUMENTS, response.data.profileDocuments)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const deleteCompanyAttachment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/businessProfile/deleteAttachment`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const fetchProfileDocumentsByUser = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/businessProfile/fetchAttachmentByUser`, data).then((response) => {
            commit(types.PROFILE_DOCUMENTS, response.data.profileDocuments)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const unsetProfileDocuments = ({ commit, dispatch, state }, data) => {
    commit(types.PROFILE_DOCUMENTS, [])
}
// process document

export const fetchProcessDocumentsByUser = ({ commit, dispatch, state },data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/fetchProcessAttachments`,data).then((response) => {
            commit(types.PROCESS_DOCUMENTS, response.data.processDocuments)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
// process document

export const addProcessAttachment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/addprocessAttachment`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
//po attchment
export const fetchPOAttachments = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/purchaseOrders/attachments`, data).then((response) => {

            commit(types.PO_ATTACHMENTS, response.data.po.media)
            commit(types.SET_TOTAL_PO_ATTACHMENTS, response.data.total)

            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const addPOAttachment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/purchaseOrders/addAttachment`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const selectPOAttachment = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECTED_PREPAYMENT_ATTACHMENTS, data)
    if (state.selectedPrepaymentAttachments.length === state.prepaymentAttachments.length) {
        commit(types.SET_SELECT_ALL_PO_STATE, true)
    } else {
        commit(types.SET_SELECT_ALL_PO_STATE, false)
    }
}
export const deletePOAttachment = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/purchaseOrders/deleteAttachment`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const deleteMultiplePOAttachments = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/purchaseOrders/deleteAttachments`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const setSelectAllPOState = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECT_ALL_PO_STATE, data)
}
export const selectAllPOAttachments = ({ commit, dispatch, state }) => {
    if (state.selectedPOAttachments.length === state.POAttachments.length) {
        commit(types.SET_SELECTED_PO_ATTACHMENTS, [])
        commit(types.SET_SELECT_ALL_PO_STATE, false)
    } else {
        let allPOAttachmentIds = state.POAttachments.map(cust => cust.id)
        commit(types.SET_SELECTED_PO_ATTACHMENTS, allPOAttachmentIds)
        commit(types.SET_SELECT_ALL_PO_STATE, true)
    }
}




